import { gql } from '@apollo/client';

const GET_UNITS_BY_GROUP = gql`
  query getUnitsByGroup($groupId: Int!) {
    unit {
      getByGroup(groupId: $groupId) {
        groupId
        id
        name
      }
    }
  }
`;

export { GET_UNITS_BY_GROUP };
